import { FC, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { getPendingTeamInviteRedirect } from './teamInviteRedirect';
import { Path } from './path';

const PendingTeamInviteRedirectConsumer: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasCheckedPendingRedirect = useRef(false);

  useEffect(() => {
    const isHomeIndexPath =
      (location.pathname === Path.HOME || location.pathname === `${Path.HOME}/`) &&
      !location.search;
    if (isHomeIndexPath) {
      return;
    }

    if (hasCheckedPendingRedirect.current) {
      return;
    }

    hasCheckedPendingRedirect.current = true;

    const pendingTeamInvitePath = getPendingTeamInviteRedirect();
    if (!pendingTeamInvitePath) {
      return;
    }

    const currentPath = `${location.pathname}${location.search}`;
    if (pendingTeamInvitePath === currentPath) {
      return;
    }

    navigate(pendingTeamInvitePath, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return null;
};

export default PendingTeamInviteRedirectConsumer;
